import * as _ from 'lodash';

import { FormControlBase } from './form-control-base';
import { FormControlData } from './form-control-data';

export class PrimeListBoxControl extends FormControlBase<any> {
  controlType = 'prime-listbox';

  constructor(options: FormControlData<any> = {}) {
    super(options);
  }

  protected initialize() {
    this.value = _.get(this.model, this.propertyName);
  }

  commit() {
    if (this.value === '') {
      _.set(this.model, this.propertyName, undefined);
    } else {
      _.set(this.model, this.propertyName, this.value);
    }
  }
}
